import {checkUserOnLoad} from '../../../functions/authCheck';
import setGlobalState from '../../../redux/setGlobalState';

// Loader function for login route
export const loginLoader = async () => {
    try {
        checkUserOnLoad().then();
        const currentLang = JSON.parse(localStorage.getItem('user.langloc')) || 'he_il';
        setGlobalState('user.langloc',currentLang);
        setGlobalState('user.lang',currentLang.split('_')[0] || 'he');
        return null;
    } catch (error) {
        return null;
    }
}; 